import { PayloadAction } from '@reduxjs/toolkit';
import { LanguageService, NotificationActions, StatsActions } from '@web_opxp/features';
import { all, call, put, select, take, takeEvery } from 'redux-saga/effects';
import { AssessmentActions } from '../assessment';
import { CYCLE_INTENSITY } from '../base/constants';
import { redirectInternal } from '../base/historyService';
import { CyclesActions, CyclesSelectors } from '../cycles';
import { DashboardRoute } from '../dashboard/Dashboard';
import { TrainingIntensityActions } from './slice';

export function* preloadCycles() {
  const isCyclesLoading = yield select(CyclesSelectors.isCyclesLoading);
  if (isCyclesLoading) {
    yield take(CyclesActions.cyclesReady);
  }
}

export function* handleIntensitySelect(action: PayloadAction<number>) {
  const intensityId = action.payload;
  const tFunction: ReturnType<typeof LanguageService.getTFunction> = yield call(LanguageService.getTFunction);
  // save selected intensity to user stats
  yield put(StatsActions.updateNumericStat(CYCLE_INTENSITY, intensityId));
  yield put(StatsActions.saveStatsQueue());
  const result = yield take([StatsActions.saveStatsQueueSuccess, StatsActions.saveStatsQueueFailed]);
  if (result.type === StatsActions.saveStatsQueueFailed.type) {
    yield put(NotificationActions.showError(tFunction('common.common:Errors.System')));
    yield put(TrainingIntensityActions.intensitySaveFailed());
    yield put(AssessmentActions.saveFailed());
    return;
  }
  // call create training second time to populate cycle with proper sessions
  const cycleCreated: boolean = yield call(createNewTrainingCycleSaga);
  if (!cycleCreated) {
    yield put(NotificationActions.showError(tFunction('common.common:Errors.System')));
    yield put(TrainingIntensityActions.intensitySaveFailed());
    yield put(AssessmentActions.saveFailed());
    return;
  }
  yield put(AssessmentActions.saveSucceed());
  redirectInternal(DashboardRoute);
}

export function* createNewTrainingCycleSaga() {
  yield call(preloadCycles);
  yield put(CyclesActions.createTraining());
  // TODO: implement an error handling here (BW-7361)
  const result = yield take([CyclesActions.trainingCreated, CyclesActions.createTrainingFailed]);
  return result.type === CyclesActions.trainingCreated.type;
}

export default function* assessmentPageWatcher() {
  yield all([takeEvery(TrainingIntensityActions.trainingIntensitySelected, handleIntensitySelect)]);
}
